var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 28.5C57 44.2401 44.2401 57 28.5 57C12.7599 57 0 44.2401 0 28.5C0 12.7599 12.7599 0 28.5 0C44.2401 0 57 12.7599 57 28.5Z",
    fill: "#F1F4F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0001 10.8555L40.0179 17.5556C40.0191 17.5562 40.0203 17.5569 40.0215 17.5575C40.6354 17.896 41 18.5426 41 19.2254V27.1489C40.9993 34.3869 36.783 40.9414 30.2666 43.761C30.2658 43.7613 30.2651 43.7616 30.2644 43.7619L30.2631 43.7625L28.4297 44.5727L28.3823 44.5882C28.2059 44.646 28.023 44.6766 27.8396 44.6801C27.661 44.6834 27.4822 44.6609 27.3088 44.6127L27.2385 44.5932L25.5213 43.8339C19.123 40.9534 15.0071 34.4619 15 27.3106L15 19.2254C15 18.5487 15.3576 17.9082 15.9617 17.5669L15.9667 17.564L28.0001 10.8555ZM17 19.2778V27.309C17.0065 33.698 20.6824 39.4607 26.3394 42.0089C26.3404 42.0093 26.3413 42.0098 26.3423 42.0102L27.811 42.6596L29.4688 41.9269L29.4703 41.9263C35.2322 39.4341 38.9994 33.6161 39 27.1489C39 27.1489 39 27.1489 39 27.1489V19.2779L28.0001 13.1453L17 19.2778Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6679 24.3278C35.0116 24.7243 34.9687 25.3243 34.5722 25.6679L27.0722 32.1679C26.8752 32.3387 26.6167 32.4209 26.3573 32.3955C26.0978 32.37 25.8602 32.239 25.7002 32.0333L22.2002 27.5333C21.878 27.1191 21.9527 26.5222 22.3668 26.2001C22.7809 25.878 23.3778 25.9526 23.6999 26.3668L26.5849 30.076L33.3279 24.2321C33.7243 23.8885 34.3243 23.9313 34.6679 24.3278Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparent);
export default __webpack_public_path__ + "static/media/transparent.452d84f3.svg";
export { ForwardRef as ReactComponent };